import { useEffect } from "react";

export const APP_TITLE = "Whitenton Tracker";
export const BASE_FAVICON = "/favicon.png";

function normalizeCount(value) {
  const count = Number(value);
  return Number.isFinite(count) && count > 0 ? Math.floor(count) : 0;
}

export function getBrowserTabAlertCount(badges = {}) {
  // Reports are already included in the Tasks count. The other two values are
  // independent Accounting work queues.
  return normalizeCount(badges.tasks)
    + normalizeCount(badges.accounting)
    + normalizeCount(badges.accountingAlerts);
}

export function formatBrowserTabTitle(count) {
  const normalized = normalizeCount(count);
  if (!normalized) return APP_TITLE;
  return `(${normalized > 99 ? "99+" : normalized}) ${APP_TITLE}`;
}

function getFaviconLink() {
  let link = document.querySelector('link[rel~="icon"]');
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    link.type = "image/png";
    document.head.appendChild(link);
  }
  return link;
}

function setBrowserAppBadge(count) {
  if (typeof navigator === "undefined") return;
  const result = count > 0
    ? navigator.setAppBadge?.(count)
    : navigator.clearAppBadge?.();
  result?.catch?.(() => {});
}

function paintFaviconAlert(link, count) {
  if (!count) {
    link.href = BASE_FAVICON;
    return () => {};
  }

  const image = new Image();
  let cancelled = false;
  image.onload = () => {
    if (cancelled) return;
    const canvas = document.createElement("canvas");
    canvas.width = 64;
    canvas.height = 64;
    const context = canvas.getContext("2d");
    if (!context) return;

    context.drawImage(image, 0, 0, 64, 64);
    context.beginPath();
    context.arc(50, 14, 12, 0, Math.PI * 2);
    context.fillStyle = "#B85C42";
    context.fill();
    context.lineWidth = 4;
    context.strokeStyle = "#FFFFFF";
    context.stroke();

    try {
      link.href = canvas.toDataURL("image/png");
    } catch {
      link.href = BASE_FAVICON;
    }
  };
  image.onerror = () => {
    if (!cancelled) link.href = BASE_FAVICON;
  };
  image.src = BASE_FAVICON;

  return () => {
    cancelled = true;
  };
}

export default function useBrowserTabAlert(badges) {
  const count = getBrowserTabAlertCount(badges);

  useEffect(() => {
    document.title = formatBrowserTabTitle(count);
    const favicon = getFaviconLink();
    const cancelFaviconUpdate = paintFaviconAlert(favicon, count);
    setBrowserAppBadge(count);
    return cancelFaviconUpdate;
  }, [count]);

  useEffect(() => () => {
    document.title = APP_TITLE;
    const favicon = document.querySelector('link[rel~="icon"]');
    if (favicon) favicon.href = BASE_FAVICON;
    setBrowserAppBadge(0);
  }, []);
}
